import { useEffect, useState } from "react";

const STEPS = [
  "Booting RECON kernel",
  "Pulling breakout candidates",
  "Filtering channels <25k subs",
  "Running clustering model",
  "Scoring 5-pillar opportunities",
  "Generating creator playbooks",
];

export default function ScanRunningModal({ open }) {
  const [step, setStep] = useState(0);
  const [pct, setPct] = useState(0);

  useEffect(() => {
    if (!open) {
      setStep(0);
      setPct(0);
      return;
    }
    let p = 0;
    const id = setInterval(() => {
      p = Math.min(p + Math.random() * 6 + 2, 95);
      setPct(Math.round(p));
      setStep(Math.min(Math.floor(p / 17), STEPS.length - 1));
    }, 450);
    return () => clearInterval(id);
  }, [open]);

  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center px-4"
      data-testid="scan-running-modal"
    >
      <div className="w-full max-w-lg bg-zinc-950 border border-zinc-800 rounded-sm overflow-hidden">
        <div className="relative h-1 bg-zinc-900 overflow-hidden">
          <div
            className="absolute inset-0 scan-sweep bg-gradient-to-b from-transparent via-yellow-400 to-transparent"
          />
        </div>
        <div className="p-8">
          <div className="font-mono text-xs uppercase tracking-[0.3em] text-yellow-400 mb-3">
            // SCAN IN PROGRESS
          </div>
          <h2 className="font-display text-2xl font-bold text-white mb-6">
            Sweeping YouTube for breakout signals
          </h2>
          <div className="space-y-2 font-mono text-sm">
            {STEPS.map((s, i) => (
              <div
                key={s}
                className={`flex items-center gap-3 ${
                  i < step
                    ? "text-zinc-500"
                    : i === step
                    ? "text-white"
                    : "text-zinc-700"
                }`}
              >
                <span className={i <= step ? "text-yellow-400" : "text-zinc-700"}>
                  {i < step ? "✓" : i === step ? "▸" : "·"}
                </span>
                <span>
                  {s}
                  {i === step ? <span className="blink">_</span> : null}
                </span>
              </div>
            ))}
          </div>
          <div className="mt-6 flex items-center justify-between font-mono text-xs text-zinc-500">
            <span>analysis_id ::= {Math.random().toString(16).slice(2, 10)}</span>
            <span className="text-yellow-400">{pct}%</span>
          </div>
        </div>
      </div>
    </div>
  );
}
